import { createContext } from 'react';
import type { OnboardingSaveStepsType } from './types';

const OnboardingSaveSteps = createContext<OnboardingSaveStepsType>(
  {} as OnboardingSaveStepsType,
);

export default OnboardingSaveSteps;
